import { Component, OnInit } from '@angular/core';

import { LocalStorageService } from 'angular-2-local-storage';

import { Sucursal } from '../../model/sucursal';
import { Consorcio } from '../../model/consorcio';

import { ReporteMovimientosSupreme } from '../../model/reporte-movimientos-supreme';

import { ConsorciosService } from '../../services/consorcios.service';
import { SucursalService } from '../../services/sucursal.service';
import { ReporteInventarioService } from '../../services/reporte-inventario.service';

@Component({
  selector: 'app-reporte-movimientos-supreme',
  templateUrl: './reporte-movimientos-supreme.component.html',
  styleUrls: ['./reporte-movimientos-supreme.component.css']
})
export class ReporteMovimientosSupremeComponent implements OnInit {

  public fechaActual: Date;
  public filtro: boolean;
  public usuario: string;
  public FechaInicio: any;
  public FechaFinal: any;
  public _filtro:string;
  public buscando: boolean;

  public documentosSeleccionadosVisual: string;
  public editMode: boolean;
  public movimientos: ReporteMovimientosSupreme[];
  public criterio: any;
  public query: any;

  constructor(
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService,
    private _inventario: ReporteInventarioService
  ) { }

  ngOnInit() {
    this._filtro = "";
    this.movimientos = [];
    this.editMode = false;
    this.buscando = false;
    this.usuario = sessionStorage.getItem("login");
    this.query = "";
    this.fechaActual = new Date();
    this.filtro = true;
    this.FechaInicio = null;
    this.FechaFinal = null;
  }

  filtroToggle() {
    this.filtro = !this.filtro;
  }

  Disabled_Button() {
    return (this.FechaInicio === null || this.FechaFinal === null);
  }


  realizarConsulta() {
    if (this.FechaInicio === null || this.FechaFinal === null) {
      return;
    }
    this.buscando = true;
    this.query = ("Inicio:"+this.FechaInicio+ "|Final:" + this.FechaFinal).toString().replace(/-/g , "/");
    this._inventario.getMovimientosSupreme({ "ETIQUETA": "MOVIMIENTOSSUPREME", "QUERY": this.query })
      .subscribe(
      data => {
        this.buscando = false;
        this.movimientos = data;
      },
      err => {
        this.buscando = false;
        console.log(err._body);
      });

    this.filtro = false;
  }

  toggleEdit() {
    this.editMode = !this.editMode;
  }

  exportar() {

    this.editMode = false;

    var ar = this.movimientos;

    //comprobamos compatibilidad
    if (window.Blob && (window.URL)) {
      var contenido = "", d = new Date(), blob, _reader, save, clicEvent;
      //creamos contenido del archivo
      for (var i = 0; i < ar.length; i++) {
        //construimos cabecera del csv
        if (i == 0)
          contenido += Object.keys(ar[i]).join(";") + "\n";
        //resto del contenido
        contenido += Object.keys(ar[i]).map(function (key) {
          return ar[i][key];
        }).join(";") + "\n";
      }
      //creamos el blob
      blob = new Blob(["\ufeff", contenido], { type: 'text/csv' });
      //creamos el reader
      _reader = new FileReader();
      _reader.onload = function (event) {
        //escuchamos su evento load y creamos un enlace en dom
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        //aquí le damos nombre al archivo
        save.download = "ReporteMovimientosSupreme" + d.getDate() + "_" + (d.getMonth() + 1) + "_" + d.getFullYear() + ".csv";
        try {
          //creamos un evento click
          clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        } catch (e) {
          //si llega aquí es que probablemente implemente la forma antigua de crear un enlace
          clicEvent = document.createEvent("MouseEvent");
          clicEvent.initEvent('click', true, true);
        }
        //disparamos el evento
        save.dispatchEvent(clicEvent);
        //liberamos el objeto window.URL
        (window.URL).revokeObjectURL(save.href);
      }
      //leemos como url
      _reader.readAsDataURL(blob);
    } else {
      //el navegador no admite esta opción
      alert("Su navegador no permite esta acción");
    }
  }

  imprimir() {

    this.editMode = false;

    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/reporte-movimientos-supreme/reporte-movimientos-supreme.component.ts